import '@vfde-brix-ws10/image/dist/styles.css';
import '@vfde-brix-ws10/video/dist/styles.css';
import '@vfde-brix-ws10/youtube-video/dist/styles.css';
import '@vfde-brix-ws10/headline/dist/styles.css';
import '@vfde-brix-ws10/button/dist/styles.css';
import '@vfde-brix-ws10/grid/dist/styles.css';
import '@vfde-brix-ws10/media-text/dist/styles.css';

import { createMediaTextComponent } from '@vfde-brix-ws10/media-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('ws10-media-text');

for (let i = 0, x = elements.length; i < x; i += 1) {

    const containerElement = elements[i].parentElement;
    createMediaTextComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
